/* eslint-disable react-hooks/exhaustive-deps */
import {Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import { serverConfig } from "../../../utils/config";
import parse from 'html-react-parser';
import { useTranslation } from "react-i18next";

const Env = serverConfig;

export const HotelCard = (props: any) => {
    const [selected, setSelected] = useState(false);
    useEffect(() => {
        if (!props.data.includes(props.id)) {
            setSelected(false)

        }
    }, [props.isSelected]);
    const toggleSelected = () => {
        props.setData([])
        props.setData([props.id])
        setSelected(!selected)
    }

    const {t} = useTranslation();
    return (
        <Grid item lg={3}>
            <Card sx={{maxWidth: 345}}>
                <CardActionArea>
                    {
                        props.image[0] !== undefined ? 
                        <CardMedia
                            component="img"
                            height="140"
                            image={ `${Env.ApiRoot}/images/hotels/${props.image[0].filename}`}
                            alt="green iguana"
                        />:""
                    }
                    
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {props.companyName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                           {props.description.length<=50 ? parse(props.description.substring(3, 50)) :  (parse(props.description.substring(3, 50))+ "...")}
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Button variant={'outlined'} size="small" color={selected ? "success" : "error"}
                            onClick={() => {
                                toggleSelected()
                                props.handleClick();
                                if(selected) {
                                    props.setHotel("")
                                } else {
                                    props.onClickHotel(props.item)
                                }
                            }}>
                        {selected ? t('label.hotel-selectionne') : t('label.choisir')}
                    </Button>
                </CardActions>
            </Card>
        </Grid>

    )

}